export default () => {
	const formRows = document.querySelectorAll('[data-minimised]');
	formRows.forEach(formRow => {
		const label = formRow.querySelector('label');
		label.setAttribute('tabindex', '0');
		['click', 'focus'].forEach(event => {
			label.addEventListener(event, () => expandAndFocusField(formRow));
		});
	});
};

export const expandAndFocusField = formRow => {
	expandField(formRow);
	makeNonTabbable(formRow);
	focusField(formRow);
};

const expandField = formRow => {
	formRow.classList.remove('form-inline-row--is-minimised');
};

const focusField = formRow => {
	formRow.querySelector('input').focus();
};

const makeNonTabbable = formRow => {
	const label = formRow.querySelector('label');
	label.removeAttribute('tabindex');
};
